import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getAdvertisement} from '../../../apis/advertisement/getAdvertisement'

const useQueryAdvertisement = () => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.advertisement.getAdvertisement(),
        queryFn: async () => {
            const {data, pageInfo} = await getAdvertisement()
            return {data, pageInfo}
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}

export default useQueryAdvertisement
